// Template Generated by DataExtraction.py at 1717541024
        
import CESGEnglishC2 from "../../Forms/CESG/CESG_EnglishC2.png";
import CESGEnglishC2Labels from "../../Labels/CESG/CESG_EnglishC2.json";
import CESGFrenchC2 from "../../Forms/CESG/CESG_FrenchC2.png";
import CESGFrenchC2Labels from "../../Labels/CESG/CESG_FrenchC2.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrenchC2Labels : CESGEnglishC2Labels;
    const formImage = isFrench ? CESGFrenchC2 : CESGEnglishC2;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const now = moment().format("yyyy/MM/DD");
    const subscriber2Include = data.common.subscriber2Include;

    // Drawing the form
    drawText(now, "s1SignatureDate");
    if (subscriber2Include)
        drawText(now, "s2SignatureDate");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrenchC2Labels : CESGEnglishC2Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    const subscriber2Include = state.common.subscriber2Include;
    
    
    // // signatureView1
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("signatureView1", labels))],
    });
    
    if (subscriber2Include) {
        // signatureView2
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("signatureView2", labels))],
        });
    }
    
    
    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    